<div class="flex form-row">
    <div class="services" *ngIf="this.isMifidRebundlingEnabled">
      <mat-form-field style="width: 72%;">
        <mat-select (selectionChange)="onServiceSelectChange();setValidityOfPackage()"
                    class="horizontal" name="services" placeholder="Services for Low Touch research *"
                    [(ngModel)]="packageDetails.service">
          <mat-optgroup label="Services for Low Touch research  *">
            <mat-option *ngFor="let service of servicesForLTResearch; let i =index" [value]="service.value">
              {{ service.display }}
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
      <i style="top: 8px;right: 2px;" class="material-icons help-icon" matTooltip="If UK and MiFID in-scope (want research):">&#xE8FD;</i>
    </div>

    <mat-form-field style="width: 72%;">
      <mat-select multiple (selectionChange)="onProductSelectChange();setValidityOfPackage()" [(value)]="leiDetail.packagesDetails[0].products"
                  class="horizontal" name="products" placeholder="Products for Low Touch research *"
                  [(ngModel)] =packageDetails.products>
        <mat-optgroup label="Products for Low Touch research  *">
          <mat-option *ngFor="let product of productsForLTResearch; let i =index" [value]="product.value"
                      [disabled]="checkProductSelection(product.value)" matTooltipClass="product-tooltip"  matTooltipPosition="right" [matTooltip]="product.value ==='FICC' ? getProductTooltip() : null">
            {{ product.display }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="leiDetail.packagesDetails[0].products.includes('FICC')">
      <mat-select class="horizontal" name="exemptions" placeholder="Exemptions for UK FICC *" [(ngModel)]="packageDetails.exemption">
        <mat-optgroup label="Exemptions for UK FICC *">
          <mat-option *ngFor="let exemption of exemptions; let i =index" [value]="exemption.value"
                      [disabled]="isExemptionSelectable()">
            {{ exemption.display }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

  </div>
